import React, { useMemo } from "react";
import objectPath from "object-path";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useSelector } from "react-redux";
import { SAAsideMenuList } from "./aside-menu/SACustomAsideMenuList";

export function Aside() {
  const uiService = useHtmlClassService();
  const { user } = useSelector(({ auth }) => ({
    user: auth.user
  }));

  const layoutProps = useMemo(() => {
    return {
      disableScroll:
        objectPath.get(uiService.config, "aside.menu.dropdown") === "true" ||
        false,
      asideClassesFromConfig: uiService.getClasses("aside", true),
      disableAsideSelfDisplay:
        objectPath.get(uiService.config, "aside.self.display") === false,
      headerLogo: uiService.getLogo()
    };
  }, [uiService]);

  const getCondition = () => {
    if (user.is_admin) {
      return true;
    } else {
      if (user.organization)
        if (
          !user.organization.simpz_status ||
          user.organization.simpz_status == "ACTIVE"
        ) {
          return true;
        } else {
          return false;
        }
    }
  };

  return (
    <>
      {/* begin::Aside */}
      {getCondition() && (
        <div
          id="kt_aside"
          className={`aside aside-left ${layoutProps.asideClassesFromConfig} d-flex flex-column flex-row-auto`}
        >
          {/* begin::Aside Menu */}
          <div
            id="kt_aside_menu_wrapper"
            className="aside-menu-wrapper flex-column-fluid"
          >
            <AsideMenu disableScroll={layoutProps.disableScroll} />
          </div>
          {/* end::Aside Menu */}
        </div>
      )}
      {/* end::Aside */}
    </>
  );
}
